import { createSlice } from "@reduxjs/toolkit";
import { fetchUsers, createUser, deleteUser, updateUser } from "../actions/usersActions";

const initialState = {
    users: [],
    loading: false,
    error: null,
    updateLoading: false, // Novo estado para o loading da atualização
    updateError: null,   // Novo estado para o erro da atualização
};

const usersSlice = createSlice({
    name: "users",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchUsers.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchUsers.fulfilled, (state, action) => {
                state.loading = false;
                state.users = action.payload.data ?? action.payload;
            })
            .addCase(fetchUsers.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(createUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(createUser.fulfilled, (state, action) => {
                state.loading = false;
                state.users.push(action.payload);
            })
            .addCase(createUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            })
            .addCase(updateUser.pending, (state) => { // Casos para o updateUser
                state.updateLoading = true;
                state.updateError = null;
            })
            .addCase(updateUser.fulfilled, (state, action) => {
                state.updateLoading = false;
                const updatedUser = action.payload;
                const index = state.users.findIndex(u => u.id === updatedUser.id);

                if (index !== -1) {
                    state.users[index] = updatedUser.data;
                }
            })
            .addCase(updateUser.rejected, (state, action) => {
                state.updateLoading = false;
                state.updateError = action.payload || action.error.message;
            })
            .addCase(deleteUser.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteUser.fulfilled, (state, action) => {
                state.loading = false;
                state.users = state.users.filter(user => user.uid !== action.payload);
            })
            .addCase(deleteUser.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    },
});

export default usersSlice.reducer;